export default __webpack_public_path__ + "static/media/noteIcon.453a92b7.svg";